<template>
   <cui-acl :roles="['underDevelopment','reports']" redirect>
    <ListWithSearch
      title="Rapporter"
      placeholder="Søk..."
      :showSettings="['underDevelopment'].some(r => $store.state.user.roles.indexOf(r) >= 0)"
      settingsPath="/reports/settings"
      :listData="reports"
      target="/reports/view/"
    />
  </cui-acl>
</template>

<script>
import cuiAcl from '@/components/cleanui/system/ACL'
import ListWithSearch from '@/components/custom/visual/ListWithSearch'
import { openNotification } from '@/services/powerAutomate'

import { firestore } from '@/services/firebase'

const reportTypes = [
  {
    value: 'iframe',
    label: 'iFrame',
  },
  {
    value: 'url',
    label: 'Link to Report',
  },
]

export default {
  components: {
    ListWithSearch,
    cuiAcl,
  },
  data() {
    return {
      reports: [],
      reportTypes,
      employees: [],
      apikey: 'wwqUGqJc7XzBvK258ZBF5OTVyFo',
    }
  },
  methods: {
    deleteReport(i) {
      firestore.collection('reports').doc(this.reports[i].id).delete()
        .then(() => {
          openNotification('success', 'Report deleted')
          this.reports.splice(i, 1)
        })
    },
    editReportSettings(i) {
      const newData = this.reports[i]
      // replace all undifined with null
      Object.keys(newData).forEach(key => {
        if (newData[key] === undefined) {
          newData[key] = null
        }
      })
      if (newData.access === undefined) {
        newData.access = []
      }
      console.log(newData)
      if (!newData.newReport) {
        delete newData.newTable
        firestore.collection('reports').doc(this.reports[i].id).update(newData)
          .then(() => {
            openNotification('success', 'Report settings updated')
          })
      } else {
        console.log(newData)
        delete newData.newReport
        this.reports[i].id = firestore.collection('reports').add(newData)
          .then(() => {
            openNotification('success', 'Report settings updated')
          }).id
      }
      newData.access.forEach(employee => {
        this.checkEmployeeRole(employee)
      })
      console.log(this.reports)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    checkEmployeeRole(id) {
      firestore.collection('users').doc(id).get()
        .then(doc => {
          if (doc.data().roles.includes('reports')) {
            return true
          } else {
            // add supporttables as access to user
            firestore.collection('users').doc(id).update({
              roles: [...doc.data().roles, 'reports'],
            })
            return true
          }
        })
    },
  },
  mounted() {
    let ref = firestore.collection('reports')
    if (['underDevelopment'].some(r => this.$store.state.user.roles.indexOf(r) >= 0)) {
      firestore.collection('users').onSnapshot(
        snapshot => {
          this.users = []
          snapshot.forEach(doc => {
            this.employees.push({
              value: doc.id,
              label: doc.data().fullName,
            })
          })
        },
      )
    } else {
      ref = ref.where('access', 'array-contains', this.$store.state.user.id)
    }
    ref.onSnapshot(snapshot => {
      this.reports = []
      snapshot.forEach(doc => {
        this.reports.push({
          id: doc.id,
          title: doc.data().title,
          subtext: doc.data().description,
          description: doc.data().description,
          newReport: false,
          access: doc.data().access,
          url: doc.data().url,
          type: 'iframe',
        })
      })
    })
  },
}
</script>

<style>

</style>
